var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"excel":_vm.isButton_(_vm.scrId, 'EX'),"index":"","paging":"","pageUnit":_vm.groups.pageUnit,"pageArray":_vm.screen.pageArray,"totalSize":_vm.groups.totalSize,"currentPage":_vm.groups.currentPage},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }